import React from 'react';
import MainPage from "./MainPage";
import MainPageText from "./MainPageText";

const AboutUs = () => {
    return (
        <div>
            <MainPage/> <br />

            <MainPageText/>
        </div>
    );
};

export default AboutUs;